import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const SignInPage: React.FC = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();

  useEffect(() => {
    if (isSignedIn) {
      navigate('/profile');
    } else {
      // Redirect to Clerk's Account Portal
      window.location.href = 'https://accounts.seaingyou.nl/sign-in?redirect_url=' + 
        encodeURIComponent(window.location.origin + '/profile');
    }
  }, [isSignedIn, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: 'calc(100vh - 70px)',
      padding: '2rem',
      backgroundColor: '#f5f5f5'
    }}>
      <p>Redirecting to sign in...</p>
    </div>
  );
};

export default SignInPage;
